import { Typography } from "../atoms/Typography";
import { Box, Container, Grid, Tabs, Tab, Fade, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { ProjectCard } from "../molecules/ProjectCard";
import { useState, useEffect } from "react";
import { Project, ProjectStatus, ProjectBelongsTo, ProjectRoleType } from "../../types/project";

const projectsData: Project[] = [
  {
    id: "project1",
    title: "Student Internship Management",
    status: ProjectStatus.ONGOING,
    summary: "The management service for students who are going to attend internship programs",
    role: "Definition and implementation of API. UX enhancement by introducing server side rendering and caching.",
    techStack: ["Next.js", "React.js", "Node.js"],
    url: "https://kagiroi.vercel.app/user/program",
    imageEnvVar: "REACT_APP_PROJECT1_IMAGE",
    belongTo: ProjectBelongsTo.CLASS,
    roleType: ProjectRoleType.SOFTWARE_ENGINEERING,
    priority: 1,
  },
  {
    id: "project2",
    title: "Blockchain-Enhanced Social Media",
    status: ProjectStatus.DONE,
    summary: "A web/mobile application similar to Twitter but with enhanced security using blockchain technology.",
    role: "Create modern and responsive frontend pages following existing mobile app design. Help API modification based on the additional demands of frontend.",
    techStack: ["React.js", "Python"],
    url: "https://www.saidso.net/",
    imageEnvVar: "REACT_APP_PROJECT2_IMAGE",
    belongTo: ProjectBelongsTo.CLASS,
    roleType: ProjectRoleType.SOFTWARE_ENGINEERING,
  },
  {
    id: "project7",
    title: "Virtual Market 2022 Summer",
    status: ProjectStatus.DONE,
    summary: "Development of the landing page for Virtual Market 2022 Summer, a major virtual reality event held from August 13 to August 28, 2022.",
    role: "Implement landing page by Vue.js following Adobe Design.",
    techStack: ["Vue.js", "SCSS"],
    url: "https://summer2022.vket.com/en",
    imageEnvVar: "REACT_APP_PROJECT6_IMAGE",
    belongTo: ProjectBelongsTo.CLASS,
    roleType: ProjectRoleType.SOFTWARE_ENGINEERING,
  },
  {
    id: "project3",
    title: "Drone Image Gallery Platform",
    status: ProjectStatus.ONGOING,
    summary: "Management service for images captured by drone.The entire codebases are composed of legacy codes and needed enhancement to reduce management costs.",
    role: "Transition the UI from old Vue.js to modern React.js.",
    techStack: ["Vue.js", "React.js"],
    url: "https://smxweb2.skymatix.jp/gallery?mediaType=ortho&mediaType=photo&mediaType=movie&page=1&sortType=0&itemsPerPage=20",
    imageEnvVar: "REACT_APP_PROJECT3_IMAGE",
    belongTo: ProjectBelongsTo.CLASS,
    roleType: ProjectRoleType.SOFTWARE_ENGINEERING,
    priority: 1,
  },
  {
    id: "project4",
    title: "Camping Community Platform",
    status: ProjectStatus.ONGOING,
    summary: "The web application to share favorite camping items.",
    role: "Improvements of UI/UX and data management",
    techStack: ["PHP", "Laravel", "HTML", "CSS", "AWS"],
    url: "https://4rent.jp/",
    imageEnvVar: "REACT_APP_PROJECT4_IMAGE",
    belongTo: ProjectBelongsTo.CLASS,
    roleType: ProjectRoleType.SOFTWARE_ENGINEERING,
  },
  {
    id: "project5",
    title: "Digital Business Card App",
    status: ProjectStatus.DONE,
    summary: "A mobile application to exchange name cards and associated information in a digitalized way.",
    role: "Implement mobile application with Flutter and backend with Laravel.",
    techStack: ["Flutter", "PHP", "Laravel", "AWS"],
    url: "https://lit-card.com/#:~:text=UI-,プロフィール情報,-サービス・SNS 全て",
    imageEnvVar: "REACT_APP_PROJECT5_IMAGE",
    belongTo: ProjectBelongsTo.CLASS,
    roleType: ProjectRoleType.SOFTWARE_ENGINEERING,
  },
  {
    id: "project6",
    title: "LogArabia",
    status: ProjectStatus.ONGOING,
    summary: "The application for Arabic learners. It enables users to translate and learn Arabic dialect at the same time.",
    role: "Planning, Design, and Management. Implement backend api and database services. Implement Landing Page with Next.js",
    techStack: ["Flutter", "Next.js", "Node.js", "Vercel", "Firebase"],
    url: "https://logarabia.com/",
    imageEnvVar: "REACT_APP_LOGARABIA_IMAGE",
    belongTo: ProjectBelongsTo.PERSONAL,
    roleType: ProjectRoleType.SOFTWARE_ENGINEERING,
    disableBlur: true,
  },
  {
    id: "project8",
    title: "Sophiary",
    status: ProjectStatus.ONGOING,
    summary: "Online dictionary application to associate image and the meaning of English.",
    role: "Planning, Design, and Management. Implement UI with Next.js",
    techStack: ["Next.js", "Node.js", "Vercel"],
    url: "https://www.sophiary-web.com/search/en-ja/glitter",
    imageEnvVar: "REACT_APP_SOPHIARY_IMAGE",
    belongTo: ProjectBelongsTo.PERSONAL,
    roleType: ProjectRoleType.SOFTWARE_ENGINEERING,
    disableBlur: true,
  },
  {
    id: "project11",
    title: "AI-Driven Marketplace",
    status: ProjectStatus.DONE,
    summary: "AI-powered merchant marketplace platform built under accelerator deadlines. Features a talking-photo avatar with local LLM inference, conversational UI for hands-free product discovery, and a personalized recommendation engine leveraging individual chat history.",
    role: "Acting CTO & Co-Founder. Led architecture design and built MVP from scratch. Collaborated with CEO on product vision, investor pitch materials, and technical roadmap.",
    techStack: ["Flutter", "FastAPI", "LLM", "Python", "AWS"],
    url: "",
    imageEnvVar: "REACT_APP_VENDELLIGENT_IMAGE",
    belongTo: ProjectBelongsTo.VENDELLIGENT,
    roleType: ProjectRoleType.SOFTWARE_ENGINEERING,
    priority: 1,
  },
  {
    id: "project9",
    title: "Sakimiru",
    status: ProjectStatus.DONE,
    summary: "Demand forecast project for retail or restaurants based on the data of past transaction, people flow, and weather forecast.",
    role: "Data engineering for entire data using SQL. Tuning of long term prediction model using Python. Introducing unit test",
    techStack: ["SQL", "Python", "AWS"],
    url: "https://www-softbank-jp.translate.goog/biz/services/analytics/sakimiru/?_x_tr_sl=ja&_x_tr_tl=en&_x_tr_hl=ja&_x_tr_pto=wapp",
    imageEnvVar: "REACT_APP_SAKIMIRU_IMAGE",
    belongTo: ProjectBelongsTo.SOFTBANK,
    roleType: ProjectRoleType.DATA_SCIENTIST,
    priority: 1,
  },
  {
    id: "project12",
    title: "Molecular Evolutionary Epigenomics",
    status: ProjectStatus.DONE,
    summary: "Graduate research at the University of Tokyo on the evolutionary epigenomics of Helicobacter pylori, exploring acquired traits through an expanded nucleotide code involving methylated bases. Findings were presented at international conferences.",
    role: "Researcher. Conducted statistical analysis and bioinformatics pipeline development. Improved lab computational environment by enhancing R workflows and introducing Python-based optimizations.",
    techStack: ["R", "Python", "Bioinformatics", "Statistical Modeling"],
    url: "",
    imageEnvVar: "REACT_APP_RESEARCH1_IMAGE",
    belongTo: ProjectBelongsTo.PERSONAL,
    roleType: ProjectRoleType.DATA_SCIENTIST,
    disableBlur: true,
    priority: 3,
  },
  {
    id: "project10",
    title: "Kaggle — Competitions Master",
    status: ProjectStatus.ONGOING,
    summary: "Ranked 3,892 of 202,646 worldwide as a Competitions Master. Active competitor for 8 years, tackling structured data, NLP, and time-series challenges.",
    role: "Designed and tuned end-to-end ML pipelines including feature engineering, cross-validation strategies, and ensemble methods to achieve top-tier rankings.",
    techStack: ["Python", "PyTorch", "LightGBM", "Scikit-Learn", "Optuna"],
    url: "https://www.kaggle.com/shinnyayoshida",
    imageEnvVar: "REACT_APP_KAGGLE_IMAGE",
    belongTo: ProjectBelongsTo.PERSONAL,
    roleType: ProjectRoleType.DATA_SCIENTIST,
    disableBlur: true,
    priority: 2,
  },
];

export const Projects = ({ isSmallScreen }: { isSmallScreen: boolean }) => {
  // Tab options
  const belongToOptions = Object.values(ProjectBelongsTo);
  const roleTypeOptions = Object.values(ProjectRoleType);

  // View mode: which dimension to filter by
  const [viewMode, setViewMode] = useState<'belongings' | 'profession'>('profession');

  // Active filter value per mode
  const [activeBelongTo, setActiveBelongTo] = useState<ProjectBelongsTo>(ProjectBelongsTo.ALL);
  const [activeRoleType, setActiveRoleType] = useState<ProjectRoleType>(ProjectRoleType.ALL);

  // State for filtered projects
  const [filteredProjects, setFilteredProjects] = useState(projectsData);

  // Filter projects whenever mode or active filter changes
  useEffect(() => {
    const result = projectsData.filter(project => {
      if (viewMode === 'belongings') {
        return activeBelongTo === ProjectBelongsTo.ALL || project.belongTo === activeBelongTo;
      } else {
        return activeRoleType === ProjectRoleType.ALL || project.roleType === activeRoleType;
      }
    });
    setFilteredProjects(result);
  }, [viewMode, activeBelongTo, activeRoleType]);

  const isAllSelected =
    (viewMode === 'profession' && activeRoleType === ProjectRoleType.ALL) ||
    (viewMode === 'belongings' && activeBelongTo === ProjectBelongsTo.ALL);

  // Sort: when All is selected, Data Scientist first then SoftBank; otherwise Done first
  const sortedProjects = [...filteredProjects].sort((a, b) => {
    if (isAllSelected) {
      const priority = (p: Project) => {
        if (p.roleType === ProjectRoleType.DATA_SCIENTIST) return 0;
        if (p.belongTo === ProjectBelongsTo.SOFTBANK) return 1;
        return 2;
      };
      return priority(a) - priority(b);
    }
    const pa = a.priority ?? 99;
    const pb = b.priority ?? 99;
    if (pa !== pb) return pa - pb;
    if (a.status === ProjectStatus.DONE && b.status !== ProjectStatus.DONE) return -1;
    if (a.status !== ProjectStatus.DONE && b.status === ProjectStatus.DONE) return 1;
    return 0;
  });

  const handleViewModeChange = (_: React.MouseEvent<HTMLElement>, newMode: 'belongings' | 'profession' | null) => {
    if (newMode !== null) setViewMode(newMode);
  };

  const handleBelongToChange = (_: React.SyntheticEvent, newValue: ProjectBelongsTo) => {
    setActiveBelongTo(newValue);
  };

  const handleRoleTypeChange = (_: React.SyntheticEvent, newValue: ProjectRoleType) => {
    setActiveRoleType(newValue);
  };

  const tabSx = {
    minHeight: '48px',
    '& .MuiTab-root': {
      color: 'white',
      opacity: 0.7,
      '&.Mui-selected': { color: '#61dafb', opacity: 1 }
    }
  };

  return (
    <Box sx={{ width: "100%", py: 4 }}>
      <Typography
        variant="h1"
        sx={{
          mb: 3,
          fontSize: {
            xs: "70px",
            sm: "70px",
            md: "70px",
            lg: "150px",
            xl: "150px",
          },
        }}
      >
        Work Experiences
      </Typography>

      <Container maxWidth="lg" sx={{ mb: 4 }}>
        {/* View mode toggle */}
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={handleViewModeChange}
            sx={{
              '& .MuiToggleButton-root': {
                color: 'white',
                borderColor: 'rgba(255,255,255,0.2)',
                fontSize: { xs: '13px', sm: '15px', lg: '17px' },
                px: 4,
                py: 1.2,
                '&.Mui-selected': {
                  color: '#61dafb',
                  backgroundColor: 'rgba(97,218,251,0.1)',
                  borderColor: '#61dafb',
                },
              },
            }}
          >
            <ToggleButton value="profession">Profession</ToggleButton>
            <ToggleButton value="belongings">Belongings</ToggleButton>
          </ToggleButtonGroup>
        </Box>

        {/* Tab row — switches based on view mode */}
        <Box sx={{
          borderBottom: 1,
          borderColor: 'divider',
          overflowX: 'auto',
          '&::-webkit-scrollbar': { height: '8px' },
          '&::-webkit-scrollbar-track': { background: '#1a2836' },
          '&::-webkit-scrollbar-thumb': { background: '#0f7f9b', borderRadius: '4px' }
        }}>
          {viewMode === 'belongings' ? (
            <Tabs
              value={activeBelongTo}
              onChange={handleBelongToChange}
              variant={isSmallScreen ? "scrollable" : "fullWidth"}
              scrollButtons="auto"
              allowScrollButtonsMobile
              TabIndicatorProps={{ style: { backgroundColor: "#61dafb" } }}
              sx={tabSx}
            >
              {belongToOptions.map(opt => (
                <Tab
                  key={opt}
                  label={opt}
                  value={opt}
                  sx={{
                    fontWeight: 500,
                    minWidth: isSmallScreen ? 'auto' : '120px',
                    fontSize: { xs: '14px', sm: '16px', md: '16px', lg: '18px' }
                  }}
                />
              ))}
            </Tabs>
          ) : (
            <Tabs
              value={activeRoleType}
              onChange={handleRoleTypeChange}
              variant={isSmallScreen ? "scrollable" : "fullWidth"}
              scrollButtons="auto"
              allowScrollButtonsMobile
              TabIndicatorProps={{ style: { backgroundColor: "#61dafb" } }}
              sx={tabSx}
            >
              {roleTypeOptions.map(opt => (
                <Tab
                  key={opt}
                  label={opt}
                  value={opt}
                  sx={{
                    fontWeight: 500,
                    minWidth: isSmallScreen ? 'auto' : '120px',
                    fontSize: { xs: '14px', sm: '16px', md: '16px', lg: '18px' }
                  }}
                />
              ))}
            </Tabs>
          )}
        </Box>
      </Container>

      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {sortedProjects.length > 0 ? (
            sortedProjects.map((project) => (
              <Grid item xs={12} key={project.id}>
                <Fade in={true} timeout={500}>
                  <Box>
                    <ProjectCard
                      title={project.title}
                      status={project.status}
                      summary={project.summary}
                      role={project.role}
                      techStack={project.techStack}
                      url={project.url}
                      imageUrl={process.env[project.imageEnvVar]}
                      isSmallScreen={isSmallScreen}
                      disableBlur={project.disableBlur}
                    />
                  </Box>
                </Fade>
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Box sx={{ 
                textAlign: 'center', 
                py: 10, 
                color: 'white', 
                opacity: 0.7 
              }}>
                <Typography variant="h5">No projects found in this category</Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </Container>
    </Box>
  );
};